import React from 'react';
import {
  Skeleton,
  SkeletonItem,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';


const useConversationListShimmerStyles = makeStyles({
  item: {
    display: 'flex',
    padding: '8px',
    width: '100%',
  },
});
export const ConversationItemShimmer = () => {
  const styles = useConversationListShimmerStyles();


  return (
    <div className={mergeClasses('conversation-item-shimmer', styles.item)}>
      <SkeletonItem shape="rectangle" style={{ height: '16px', width: '99%', opacity: 0.7 }} />
    </div>
  );
};

export const ConversationListShimmer = () => (
  <Skeleton>
    {Array.from({ length: 24 }, (_, index) => (
      <ConversationItemShimmer key={index} />
    ))}
  </Skeleton>

);
